import { render, staticRenderFns } from "./17.vue?vue&type=template&id=16195062&scoped=true&"
var script = {}
import style0 from "./17.vue?vue&type=style&index=0&id=16195062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16195062",
  null
  
)

export default component.exports